import { withStyles } from '@mui/styles'
import { ClassNameMap } from '@mui/styles/withStyles'

import { themeStyles } from 'themes'

import { warningImgYellow } from '../../utils'

const WarningAlertForPlayground = ({ classes }: { classes: ClassNameMap }) => (
    <div className={classes.root}>
        <div className={classes.innerBox}>
            <img className={classes.warningImg} src={warningImgYellow} alt="Warning" />
            <div data-sta-id="warning-alert-div-playground-enabled">
                This is a playground mode covering all the major functionality, which can be implemented for your own brand.
            </div>
        </div>
    </div>
)

export default withStyles(themeStyles.useAlertComponentsStyles)(WarningAlertForPlayground)

